export const permissions = {
	authorizationRead: "authorization:read",
	authorizationPutPolicy: "authorization:putPolicy",
	authorizationDeletePolicy: "authorization:deletePolicy",
	authorizationPutPolicyUsage: "authorization:putPolicyUsage",
	authorizationDeletePolicyUsage: "authorization:deletePolicyUsage",
};
